import { render } from "./ShioriView.vue?vue&type=template&id=6687fd1d&scoped=true"
import script from "./ShioriView.vue?vue&type=script&lang=js"
export * from "./ShioriView.vue?vue&type=script&lang=js"

import "./ShioriView.vue?vue&type=style&index=0&id=6687fd1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6687fd1d"]])

export default __exports__